import React, { useEffect, useRef } from "react";
import { Container, Graphics } from "@pixi/react";
import { useSelector } from "react-redux";
import { ASSET_NAME } from "../../../assets";
import FreeSpinIntro from "../../../Elements/Textures/FreeSpinIntro";
import FreeSpinOutro from "../../../Elements/Textures/FreeSpinOutro";
import FreeSpinInfo from "../../../Elements/Textures/FreeSpinInfo";
import anime from "animejs";

const FreeSpinsAnimation = ({ dimensions, symbolSize }) => {
  // Creating a ref to attach to the Graphics component for animation
  const { showFreeSpinIntro, showFreeSpinInfo, showFreeSpinOutro } =
    useSelector((state) => state.animations);
  const graphicsRef = useRef(null);

  // Accessing animation states from the Redux store
  const {
    freeSpinIntroAnimationStarted,
    freeSpinIntroAnimationCompleted,
    freeSpinOutroAnimationStarted,
    freeSpinOutroAnimationCompleted,
    freeSpinInfoAnimationStarted,
    freeSpinInfoAnimationCompleted,
  } = useSelector((state) => state.animations);

  // useEffect to handle animations based on the animation states
  useEffect(() => {
    if (graphicsRef.current) {
      anime({
        targets: graphicsRef.current,
        alpha:
          freeSpinIntroAnimationStarted ||
          freeSpinOutroAnimationStarted ||
          freeSpinInfoAnimationStarted
            ? [0, 1] // Fade in when any animation starts
            : freeSpinIntroAnimationCompleted &&
              !freeSpinOutroAnimationStarted &&
              !freeSpinInfoAnimationStarted
            ? [1, 0] // Fade out if intro completed and no other animations are starting
            : freeSpinOutroAnimationCompleted &&
              !freeSpinIntroAnimationStarted &&
              !freeSpinInfoAnimationStarted
            ? [1, 0] // Fade out if outro completed and no other animations are starting
            : freeSpinInfoAnimationCompleted &&
              !freeSpinIntroAnimationStarted &&
              !freeSpinOutroAnimationStarted
            ? [1, 0] // Fade out if info animation completed and no other animations are starting
            : [0, 0], // Default to no change
        duration: 400,
        easing: "easeInOutQuad",
      });
    }
  }, [
    freeSpinIntroAnimationStarted,
    freeSpinIntroAnimationCompleted,
    freeSpinOutroAnimationStarted,
    freeSpinOutroAnimationCompleted,
    freeSpinInfoAnimationStarted,
    freeSpinInfoAnimationCompleted,
  ]);

  // Rendering the component
  return (
    <Container
      name="FreeSpinsBackground"
      width={dimensions.width}
      height={dimensions.height}
      x={0}
      y={0}
      sortChildren
      zIndex={4}
    >
      <Graphics
        ref={graphicsRef}
        width={dimensions.width}
        height={dimensions.height}
        draw={(g) => {
          g.clear();
          g.beginFill(0x000000, 0.85);
          g.drawRect(0, 0, dimensions.width, dimensions.height);
          g.endFill();
        }}
      />

      {showFreeSpinIntro && (
        <FreeSpinIntro
          animationPath={ASSET_NAME.freeSpinStart}
          x={dimensions.width / 2}
          y={dimensions.height / 2}
          zIndex={5}
          symbolSize={symbolSize}
          dimensions={dimensions}
        />
      )}

      {showFreeSpinInfo && (
        <FreeSpinInfo
          animationPath={ASSET_NAME.freeSpinStart}
          x={dimensions.width / 2}
          y={dimensions.height / 2}
          zIndex={5}
          symbolSize={symbolSize}
          dimensions={dimensions}
        />
      )}

      {showFreeSpinOutro && (
        <FreeSpinOutro
          animationPath={ASSET_NAME.freeSpinEnd}
          x={dimensions.width / 2}
          y={dimensions.height / 2}
          zIndex={5}
          symbolSize={symbolSize}
          dimensions={dimensions}
        />
      )}
    </Container>
  );
};

export default FreeSpinsAnimation;
